import {
  Dashboardv20240509Api,
  dashboardv20240509Client
} from '@sequencehq/api/dashboard/v20240509'
import { fetchQuery } from '@sequencehq/api'
import { useCallback } from 'react'
import {
  dashboardv99990101Client,
  Dashboardv99990101CommonModels
} from '@sequencehq/api/dashboard/v99990101'
import { apiQueryClient } from 'features/api/apiQueryClient'
import { MINUTES } from '@sequencehq/utils/dates'

export type ApiCustomer = Dashboardv99990101CommonModels.Customers.Customer & {
  aliases: { value: string; id: string; label?: string }[]
}

export type v1ApiCustomer = ApiCustomer

type UseLoadSingleCustomer = () => (props: {
  customerId: string
}) => Promise<v1ApiCustomer | null>

export const useLoadSingleCustomer: UseLoadSingleCustomer = () => {
  const load = useCallback(async ({ customerId }: { customerId: string }) => {
    const [selectedCustomer, selectedCustomerAliases] = await Promise.all([
      customerId
        ? fetchQuery(
            apiQueryClient,
            dashboardv99990101Client.getCustomer,
            { id: customerId },
            { staleTime: 10 * MINUTES }
          )
        : Promise.resolve(null),
      customerId
        ? fetchQuery(
            apiQueryClient,
            dashboardv20240509Client.getCustomerAliases,
            { id: customerId },
            { staleTime: 10 * MINUTES }
          )
        : Promise.resolve(null)
    ])

    if (!selectedCustomer) {
      return null
    }

    return {
      ...selectedCustomer,
      aliases: (selectedCustomerAliases?.items ?? []).map(
        (alias: Dashboardv20240509Api.GetCustomerAliases.CustomerAlias) => ({
          value: alias.value,
          id: alias.id,
          label: alias.value
        })
      )
    }
  }, [])

  return load
}
